/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClientStatusCounselorRequest
 */
export interface UpdateClientStatusCounselorRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStatusCounselorRequest
     */
    status: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStatusCounselorRequest
     */
    assignedCounselorId: string | null;
}

/**
 * Check if a given object implements the UpdateClientStatusCounselorRequest interface.
 */
export function instanceOfUpdateClientStatusCounselorRequest(value: object): value is UpdateClientStatusCounselorRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    return true;
}

export function UpdateClientStatusCounselorRequestFromJSON(json: any): UpdateClientStatusCounselorRequest {
    return UpdateClientStatusCounselorRequestFromJSONTyped(json, false);
}

export function UpdateClientStatusCounselorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientStatusCounselorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'assignedCounselorId': json['assignedCounselorId'],
    };
}

export function UpdateClientStatusCounselorRequestToJSON(json: any): UpdateClientStatusCounselorRequest {
    return UpdateClientStatusCounselorRequestToJSONTyped(json, false);
}

export function UpdateClientStatusCounselorRequestToJSONTyped(value?: UpdateClientStatusCounselorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'assignedCounselorId': value['assignedCounselorId'],
    };
}

